import {splitPath} from './splitPath';

/**
 * Gets the property value at `path` from `object`.  If the value cannot
 * resolved or is `undefined`, the `defaultValue` is returned.
 *
 * @example
 * const object = { 'foo': [{ 'bar': { 'baz': 1 } }] }
 * get(object, 'foo[0].bar.baz');
 * // => 1
 *
 * @function get
 * @param {Object} object The object to query.
 * @param {string} path The path of the property to get.
 * @param {*} [defaultValue] The returned value for unresolved properties.
 * @return {*} Returns the value from the specified `path`.
 */
export default function get(object, path, defaultValue) {
	if (!object || !path) return defaultValue;

	const parts = splitPath(path);
	let here = object;
	const {length: partsCount} = parts;
	for (let i = 0; i < partsCount; i++) {
		if (!here || !Object.prototype.hasOwnProperty.call(here, parts[i])) return defaultValue;
		here = here[parts[i]];
	}

	return here !== undefined ? here : defaultValue;
}
